<template>
  <oil-form v-if="loading"
            :title="title"
            :createForm="!id"
            :items="payment"
            :keys="keys"
            @SupplierId="changeSupplier"
            @ContractId="changeContract"
            @InvoiceId="changeInvoice"
            :formCallback="formCallback"
  >
    <template v-slot:Info>
      <h3>Информация</h3><br/>
      <v-row>
        <v-col cols="12">
          <v-text-field v-model="payment.Supplier.Name" readonly outlined dense
                        label="Названия фирмы"/>
        </v-col>
        <v-col cols="12">
          <v-text-field v-model="payment.Supplier.BankName" readonly outlined dense
                        label="Банк покупателя"/>
        </v-col>
        <v-col cols="6">
          <v-text-field v-model="payment.Supplier.TaxNo" readonly outlined dense
                        label="ИНН"/>
        </v-col>
        <v-col cols="6">
          <v-text-field v-model="payment.Supplier.VatNo" readonly outlined dense
                        label="Код НДС"/>
        </v-col>
        <v-col cols="12">
          <v-text-field v-model="payment.Supplier.AccountNumber" readonly outlined dense
                        label="Расчетный счет"/>
        </v-col>
        <v-col cols="12">
          <v-text-field v-model="payment.Supplier.BankAddress" readonly outlined dense
                        label="Адрес банка"/>
        </v-col>
      </v-row>
    </template>

  </oil-form>

</template>

<script>
import keys from './setting/coming_payment_supplier.json'
import {coreApi} from "~/services/core";
import {num2str} from "~/utils/functions/MoneyFromString";

export default {
  props: {
    id: String
  },
  data: () => ({
    loading: false,
    title: 'Создать платеж',
    payment: {
      Supplier: {},
      Contract: {},
      Invoice: {},
      Number: '',
      StartDate: '',
      Amount: '',
      AmountWords: '',
      Comment: '',
      AdditionalInformation: ''
    },
    keys: keys,
    suppliers: [],
    contracts: [],
    invoices: []
  }),
  components: {
    OilForm: () => import('@/components/helper/oil.form')
  },
  async created() {
    const suppliers = await coreApi.get(`suppler`)
    this.suppliers = suppliers.data

    if (this.id) {
      this.title = 'Инфо о платежи'
      const payment = await coreApi.get(`coming-payment/supplier?id=${this.id}`)
      this.payment = payment.data
      await this.changeSupplier(this.payment.Supplier)
    }

    this.loading = true
  },
  computed: {
    storeType() {
      return this.id ? coreApi.put : coreApi.post
    },
    message(){
      return this.id ? 'платеж удачно изменен' : 'платеж удачно создан'
    }
  },
  methods: {
    async formCallback(data, input,form, func) {
      input.isEdit = false
      const response = await this.storeType(`coming-payment/supplier`, data)

      if (!response.data) {
        input.isEdit = true
        return
      }

      func(this.message)
      if (!this.id) {
        await this.$router.push({
          name: 'coming-payment-supplier',
          params: {id: response.data.Id}
        })
      }

      input.isEdit = false
    },
    async changeSupplier(supplier) {
      if (!supplier) return
      this.payment.Supplier = {...supplier}
      this.contracts = supplier.Contracts
      const invoices = await coreApi.get(`coming-invoice/supplier/${supplier.Id}`)
      this.invoices = invoices.data
      console.log(this.invoices)
    },
    async changeContract(contract) {
      if (!contract) return
      this.payment.Contract = {...contract}
    },
    async changeInvoice(invoice) {
      if (!invoice) return
      this.payment.Invoice = {...invoice}
    }
  },
  watch: {
    suppliers(suppliers) {
      this.keys["Supplier.Id"].attrs.items = suppliers
    },
    contracts(contracts) {
      this.keys["Contract.Id"].attrs.items = contracts
    },
    invoices(invoices) {
      this.keys["Invoice.Id"].attrs.items = invoices
    },
    'payment.Amount'(amount) {
      this.payment.AmountWords = num2str(amount)
    }
  }
}
</script>
